import {
  getETIDocumentEndPoint,
  getETIEndPoint,
  getETIFileDownloadEndPoint,
  getETISurveyJSJsonEndPoint,
} from '../../../../common/api.endPoints';
import { FetchService } from '../../../../common/fetch.service';
import { HttpService } from '../../../../common/http.service';

export const getETI = (taskId: number) => {
  return HttpService.getInstance().get(getETIEndPoint(taskId));
};

export const getAttachment = (key: string) => {
  return HttpService.getInstance().get(getETIDocumentEndPoint(key));
};

export const getSurveyJSJson = (taskId: number) => {
  return FetchService.getInstance().get(getETISurveyJSJsonEndPoint(taskId));
};

export const downloadEtiFile = async (
  policyId: number,
  taskId: number,
  fileUuid: string,
): Promise<string> => {
  const endpoint = getETIFileDownloadEndPoint(policyId, taskId, fileUuid);
  const response = await FetchService.getInstance().get(endpoint);
  return (response as { url: string }).url;
};
